// Global history API wrapper to prevent crashes/freezes on file:// protocol
        (function() {
            try {
                const originalPush = window.history.pushState;
                const originalReplace = window.history.replaceState;
                
                window.history.pushState = function(state, title, url) {
                    try {
                        if (window.location.protocol === 'file:') {
                            return originalPush.call(window.history, state, title, '');
                        }
                        return originalPush.call(window.history, state, title, url);
                    } catch (e) {
                        console.warn("History pushState blocked or failed:", e);
                    }
                };
                
                window.history.replaceState = function(state, title, url) {
                    try {
                        if (window.location.protocol === 'file:') {
                            return originalReplace.call(window.history, state, title, '');
                        }
                        return originalReplace.call(window.history, state, title, url);
                    } catch (e) {
                        console.warn("History replaceState blocked or failed:", e);
                    }
                };
            } catch (err) {
                console.warn("Failed to patch history API:", err);
            }
        })();

        (function () {
            var path = window.location.pathname;
            // Clean up index.html from the address bar URL immediately
            if (path.endsWith('index.html')) {
                var cleanPath = path.slice(0, -10);
                if (cleanPath === '') cleanPath = '/';
                try {
                    window.history.replaceState(null, '', cleanPath + window.location.search + window.location.hash);
                } catch (e) { }
                path = cleanPath;
            }
            // Clean up trailing slashes
            if (path !== '/' && path.endsWith('/')) {
                path = path.slice(0, -1);
            }
            // Update link element
            var canonicalUrl = 'https://qrbloomsuite.com' + (path === '/' ? '' : path);
            var link = document.getElementById('canonical-link');
            if (link) {
                link.setAttribute('href', canonicalUrl);
            }
        })();